// eslint-disable-next-line import/prefer-default-export
export const ERROR_DISMISS = 'errors/DISMISS';
